<template>
  <div class="sub_container">
		<section class="sub_contents">
			<div class="sub_contents_wrap">
				<h1>공지사항 컨텐츠</h1>
				<div class="ins_detail_title">
					<h2 class="pt10">공지사항</h2>
					<div class="sub_right_wrap">
						<div class="btn_area pb0">
							<!-- <a class="button white" @click="regFileBtn" v-if="!isRead"><span>첨부파일 업로드</span></a> -->
							<a class="button white" @click="downFileBtn" v-if="isRead"><span>첨부파일 다운로드</span></a>
							<!-- <a class="button white" @click="delFileBtn" v-if="!isRead"><span>첨부파일 삭제</span></a> -->
							<a class="button white" @click="listBtn"><span>목록</span></a>
							<!-- <a class="button blue" @click="updateBtn" v-if="isRead && isWriteUser()"><span>수정</span></a>
							<a class="button blue" @click="saveBtn" v-if="!isRead"><span>저장</span></a> -->
						</div>
					</div>
				</div>
				<div class="notice_wrap mb0 p0 mt10">
					<div class="notice_detail_con">
						<div class="ins_de_row">
							<div class="cell">
								<label for="">제목</label>
								<input type="text" placeholder="제목을 입력하세요." autocomplete="off"
										:readonly="isRead"
										v-model="contentObj.subject">
							</div>
						</div>
						<div class="ins_de_row">
							<div class="cell" style="padding-top: 0px; top: 10px; border-bottom-width: 0px;
                  border-top: 1px solid #e8e8e8 !important;
                  background-color: white;
                  border-right: 1px solid #e8e8e8 !important;
                  border-left: 1px solid #e8e8e8; !important">
								<label class="bordn0" for="" style="float: left; border-right: 1px solid #e8e8e8 !important;">첨부파일
									<input type="checkbox" style="width: 15px; margin-left: 15px;"
											v-model="isCheckAll"
											@change="clickAllUploadFile">
								</label>
								<div style="line-height: 35px;">
									<template v-for="(file, index) in uploadFileList">
										<span class="bordr1" style="width: 100%; padding-left: 10px;"
												:key="index" >
											<input type="checkbox" class="mr10 ml10" style="width: 15px;"
													:value="file.fileNo == undefined ? 0 : file.fileNo"
													:id="index"
													v-model="uploadFileCheckList"
													@change="clickUploadFile(index)">
											<label :for="index" class="pr10">{{file.origrinFileName}}</label>
										</span>
									</template>
								</div>
								<input type="file" id="fileElement" class="image_file" multiple="multiple"
										v-show="false" @change="addFileFunc">
							</div>
						</div>
					</div>
				</div>
				<template v-if="!isRead">
					<div class="ins_detail_wrap mb0 p0" style="border-top: 0px; border-bottom: 1px solid #000;">
						<div class="ins_detail_con">
							<div class="ins_de_row">
								<div class="cell">
									<label for="">분류</label>
									<div class="cell_select-02" style="width: 200px">
										<div class="cell_se_bg-02_board">
											<select-code-list 
													:id="'bulletinBoardTypeCode'"
													:codeType="'BULLETIN_BOARD_TYPE_CODE'"
													:allYn="'N'"
													v-model="noticeOption.typeCode" />
										</div>
									</div>
								</div>
								<div class="cell">
									<label for="">상단 고정 여부</label>
									<input type="checkbox" style="width: 25px; margin-left: 15px;"
											v-model="noticeOption.isFixUpper">
								</div>
								<div class="cell">
									<label for="">Popup 여부</label>
									<input type="checkbox" style="width: 25px; margin-left: 15px;"
											v-model="noticeOption.isPopupShow">
								</div>
								<div class="cell">
									<label for="">표시 기간</label>
									<div class="date_wrap">
										<div class="date_input">
											<span class="inputbd" style="width: 91px;">
												<input-date
														:disabled="'disabled'"
														v-model="noticeOption.showStDate" />
											</span>
										</div>
										<div class="date_input pl10">
											<span class="inputbd" style="width: 91px;">
												<input-date
														v-model="noticeOption.showEdDate" />
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div class="notice_view mt20">
					<!-- Web editor -->
					<web-editor ref="myTextEditor"
											v-if="isTest"
                      v-model="contentObj.content"
                      :options="editorOption"
											:disabled="isRead"
											:minHeight="500"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)"
											@imageUpload="onImageUpload($event)"
											@videoUpload="onVideoUpload($event)"></web-editor>
					<textarea cols="30"
							v-else
							:readonly="isRead"
							v-model="contentObj.content">
						Test
					</textarea>
				</div>
				<template v-if="isRead">
					<div class="ins_detail_wrap mb0 p0 mt10">
						<div class="ins_detail_con pt10">
							<template v-for="(reply, index) in commentList">
								<div class="ins_de_row" :key="index">
									<div class="cell pt2">
										<label style="width: 70px;">
											<input type="checkbox" style="width: 15px; margin-left: 15px;"
													v-if="reply.updateUserNo == loginUserNo"
													:value="reply.bulletinContentNo"
													@change="chngCommentCheck"
													v-model="pickCommentList"/>
										</label>
										<textarea cols="30" class="pl10"
												style="width: calc(52% + 13px);"
												:readonly="reply.edit == false"
												v-model="reply.bulletinContent"></textarea>
										<div style="
													background: #f5f5f5;
													border: 1px solid #e8e8e8;
													float: right;
													padding-left: 10px;
													padding-right: 13px;
													width: 173.6px;">
											<div :title="reply.createUserName"
													style="
													width: 95px;
													text-overflow: ellipsis;
													overflow: hidden;
													white-space: nowrap;">{{reply.createUserName}}</div>
											<span
													style="
													width: 95px;
													text-overflow: ellipsis;
													overflow: hidden;
													white-space: nowrap;">{{reply.writeDate}}</span>
										</div>
									</div>
								</div>
							</template>
							<div class="ins_de_row">
								<div class="cell">
									<label style="width: 70px;">신규댓글</label>
									<textarea cols="30"
											style="width: calc(75% + 47.5px);"
											v-model="commentObj.content"
											:disabled="!isRead">
										댓글
									</textarea>
								</div>
							</div>
						</div>
						<div class="sub_right_wrap" v-if="isRead">
							<div class="btn_area">
								<a class="button gray" v-if="pickCommentList.length == 1" @click="updateCommentBtn"><span>댓글수정</span></a>
								<a class="button gray" v-if="pickCommentList.length > 0" @click="deleteCommentBtn"><span>댓글삭제</span></a>
								<a class="button blue" @click="regCommentBtn"><span>댓글등록</span></a>
							</div>
						</div>
					</div>
				</template>
			</div>
		</section>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import FileUtils from '@/modules/file'
import SelectCodeList from '@/components/SelectCodeList'
import InputDate from '@/components/InputDate'
import WebEditor from '@/components/webEditor/WebEditor'

export default {
	name: 'Write',
	components: { 
		SelectCodeList,
		InputDate,
		WebEditor
	},
	computed: {
		refBoardNo() { // 게시글 번호
			return this.$route.params.refBulletinBoardNo == undefined ? 0 : this.$route.params.refBulletinBoardNo;
		},
		loginUserNo() { // 접속 사용자 번호
			return window.$store.getters['Login/getUserNo'];
		},
    userRoleLevel () { // 사용자 권한
      return window.$store.getters['Login/getRoleLevel']
		},
		editor() {
			return this.$refs.myTextEditor.quill
		}
	},
	data() {
		return {
			isTest: true,
			boardTitle: '시인규',
			isNew: false,
			isRead: false,
			fromPage: 'boardList',
			uploadFileList: [], // 업로드한 파일리스트
			uploadFileCheckList: [], // 업로드한 파일 선택 리스트
			deleteFileList: [], // 삭제 파일리스트
			isCheckAll: false, // 업로드한 파일 전체체크 여부
			authUserNo: 0, // 읽기 조건에서 작성자
			contentObj: { // 게시글 설정
				subject: '',
				content: '',
				fileGroupNo: 0,
				imageGroupNo: 0,
				trgtImageFileNo: 0
			},
			commentList: [], // 기등록 댓글
			pickCommentList: [], // 선택한 기등록 댓글 리스트
			commentObj: { // 신규 댓글 설정
				content: ''
			},
			noticeOption: { // 게시글 속성 설정
				typeCode: '10',
				isFixUpper: false,
				isPopupShow: false,
				showStDate: '',
				showEdDate: '',
				showPeriod: 14 // 공시기간
			},
			editorOption: {
				modules: {
					toolbar: [
						[{ 'size': ['small', false, 'large', 'huge'] }],
						[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
						[{ 'font': [] }],
						['bold', 'italic', 'underline', 'strike'],
						[{ 'color': [] }, { 'background': [] }],
						[{ 'indent': '-1' }, { 'indent': '+1' }],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						[{ 'align': [] }],
						[{ 'script': 'sub' }, { 'script': 'super' }],
						['blockquote', 'code-block'],
						['link', 'image']
					]
				}
			}
		}
	},
	mounted() {
		const vm = this;

		// 타이틀 설정
		this.isNew = this.$route.params.isNew;
		this.isRead = this.$route.params.isRead;
		this.fromPage = this.$route.params.fromPage;
		
		if (this.isNew == undefined || this.isRead == undefined) {
			setTimeout(function() {
				vm.$router.push({
					name: 'BoardList',
					params: { }
				});
				window.$store.dispatch('LatestMenu/deleteLatestMenu', {name: 'Write'});
			}, 10);
    }
    
    document.getElementsByClassName('ql-toolbar')[0].remove();
    
		if (this.isNew) {
			this.boardTitle = '신규';
			document.getElementsByClassName('ql-toolbar ql-snow')[0].classList.remove('displayNone');
		} else if (!this.isNew && this.refBoardNo != 0 && !this.isRead) {
			this.boardTitle = '수정';
			this.selectContentDetail(); // 게시글 상세 조회
		} else if (this.isRead) { // 읽기
			this.boardTitle = '';
			this.selectContentDetail(); // 게시글 상세 조회
		}
		
		// 표시기간 설정
		const today = Utils.getToday();
		this.noticeOption.showStDate = today;
		this.noticeOption.showEdDate = Utils.getAddDay(today, this.noticeOption.showPeriod);

	},
	methods: {
		regFileBtn() { // 첨부파일 업로드 버튼 클릭
      const ele_file = document.getElementById("fileElement");
      ele_file.click();
		},
		downFileBtn() { // 첨부파일 다운로드 버튼 클릭
			const agent = navigator.userAgent.toLowerCase();
			for (let i in this.uploadFileCheckList) {
				const fileNo = this.uploadFileCheckList[i];
				if ( fileNo != 0 ) {
					const downUrl = '/common/file/download/'+ fileNo;
					const trgtIdx = this.uploadFileList.findIndex(el => {
						return el.fileNo == fileNo;
					});
					const fileName = this.uploadFileList[trgtIdx].origrinFileName;

					if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1)
							|| (agent.indexOf("msie") != -1) ) {
						var xAuthToken = Vue.httpClient.defaults.headers.common['x-auth-token'];
						location.href = AppConfig.HTTP_CONFIG.baseURL + downUrl +'?xAuthToken='+ xAuthToken;
					} else {
						Vue.httpClient
							.get(downUrl, {
								responseType: 'arraybuffer'
							})
							.then((response) => {
								FileUtils.getFile(response, fileName)
							});
					}
				}
			}
		},
		delFileBtn() { // 첨부파일 삭제 버튼 클릭
			if (this.isCheckAll) {
				if (!this.isNew) {
					for (let i in this.uploadFileList) {
						this.deleteFileList.push(this.uploadFileList[i].fileNo);
					}
				}
				this.uploadFileList = [];
				this.uploadFileCheckList = [];
				this.isCheckAll = false;
				return false;
			}

			let tempUploadFileCheckList = this.uploadFileCheckList.slice();
			
			for (let i in tempUploadFileCheckList) {
				
				if ((this.uploadFileList[i] == undefined && this.isNew)
						|| this.uploadFileList[i].fileNo == undefined
						|| this.uploadFileList[i].fileNo == 0) {
					// 목록 신규
					this.uploadFileList.splice(this.uploadFileCheckList[i], 1);
					this.uploadFileCheckList.splice(i, 1);
				} else {
					// 목록 수정
					let uploadFileIdx = this.uploadFileList.findIndex(el => {
						return el.fileNo == tempUploadFileCheckList[i];
					});
					let uploadFileCheckIdx = this.uploadFileCheckList.findIndex(el => {
						return el.fileNo == tempUploadFileCheckList[i];
					});
					this.deleteFileList.push(tempUploadFileCheckList[i]);
					this.uploadFileList.splice(uploadFileIdx, 1)
					this.uploadFileCheckList.splice(uploadFileCheckIdx, 1)
				}
			}

			if (this.uploadFileList.length == this.uploadFileCheckList.length
					&& this.uploadFileList.length != 0) {
				this.isCheckAll = true;
			} else {
				this.isCheckAll = false;
			}

		},
		saveBtn() { // 게시글 저장 버튼 클릭
			let tempUploadFileList = [];
			let params = new FormData();
			let contentObj = {}
			// 1. 신규의 경우 this.refBoardNo가 0
			params.append("refBoardNo", this.refBoardNo);

			// 2-1. 첨부파일 준비(신규의 경우 fileGroupNo가 0)
			let fileGroupNo = this.contentObj.fileGroupNo == undefined ? 0 : this.contentObj.fileGroupNo;
      
			params.append("fileGroupNo", fileGroupNo);
			for (let i in this.uploadFileList) {
				params.append("uploadFiles", this.uploadFileList[i].file);
			}
			
			for (let i in this.deleteFileList) {
				params.append("deleteFiles", this.deleteFileList[i]);
			}

			// 2-1. 이미지 그룹 준비
			params.append("imageGroupNo", this.contentObj.imageGroupNo);

			// 3. 게시글 준비
			params.append("subject", this.contentObj.subject);
			if (this.contentObj.subject == null || this.contentObj.subject == '') {
				Vue.Alert.alert('제목을 입력해주세요.');
				return false;
			}
			params.append("content", this.contentObj.content);
			if (this.contentObj.content == null || this.contentObj.content == '') {
				Vue.Alert.alert('글 내용을 입력해주세요');
				return false;
			}

			// 4. 게시글 옵션 준비
			params.append("typeCode", this.noticeOption.typeCode);
			params.append("priority", this.noticeOption.isFixUpper ? 0 : 1);
			params.append("popupYn", this.noticeOption.isPopupShow);
			params.append("showStDate", this.noticeOption.showStDate);
			params.append("showEdDate", this.noticeOption.showEdDate);

			Vue.httpClient
				.post('/board/saveContent', params, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
				})
				.then(response => {
					if (response.data.result) {
						this.setMainContent(response.data.result);
						this.isNew = false;
						this.isRead = true;
						this.boardTitle = '';
						// 첨부파일 선택, 삭제 리스트 초기화
						this.uploadFileCheckList = [];
						this.deleteFileList = [];

						this.listBtn();

					}
				})
		},
		updateBtn() { // 읽기 상태에서 게시글 수정버튼 클릭시
			this.isNew = false;
			this.isRead = false;

			// 툴바 설정
			
		},
		listBtn() { // 목록 버튼 클릭시
			const vm = this;
			let trgtPage = this.fromPage;

			if (trgtPage == null || trgtPage == undefined || trgtPage == '') {
				trgtPage = 'BoardList';
			} 
			
			setTimeout(function() {
				vm.$router.push({
					name: trgtPage
				});
				window.$store.dispatch('LatestMenu/deleteLatestMenu', {name: 'Write'});
			}, 10);
		},
		regCommentBtn() { // 댓글등록 버튼 클릭
			const vm = this;
			if (this.refBoardNo == undefined || this.refBoardNo == 0) {
				setTimeout(function() {
					vm.$router.push({
						name: 'BoardList'
					});
					window.$store.dispatch('LatestMenu/deleteLatestMenu', {name: 'Write'});
				}, 10);
				return false;
			}

			if (this.isEmpty(this.commentObj.content)) {
				return false;
			}

			const params = {
				content: this.commentObj.content,
				bulletinBoardNo: this.refBoardNo,
				bulletinContentNo: this.commentList.length == 0 ? 0 : this.commentList[1],
				bulletinContentTypeCode: this.noticeOption.typeCode
			}
			Vue.httpClient
				.post('/board/saveComment', params)
				.then(response => {
					if (response.data.result) {
						this.commentList = response.data.result.commentList;
						this.commentObj.content = '';
					}
				})
		},
		isEmpty(value) {
			const regExp = /\s/gi;
			value = value.replace(regExp,'');
			if ( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ) {
				return true;
			} else {
				return false;
			}
		},
		updateCommentBtn() { // 댓글수정 버튼 클릭
			if (this.pickCommentList.length != 1) {
				Vue.Alert.alert('여러 항목이 선택되었습니다. 수정은 한건만 선택해주세요.');
				return false;
			}

			let commentIdx = 0;
			for (let i in this.pickCommentList) {
				commentIdx = this.commentList.findIndex(el => {
					return el.bulletinContentNo == this.pickCommentList[i];
				});
			}

			if (commentIdx < 0) {
				Vue.Alert.alert('선택된 항목이 없습니다. 항목을 선택해주세요.');
				return false;
			}

			const authUser = this.commentList[commentIdx].updateUserNo;

			

			const params = {
				bulletinBoardNo: this.refBoardNo,
				bulletinContentNo: this.pickCommentList[0],
				content: this.commentList[commentIdx].bulletinContent,
			}
			
			Vue.httpClient
				.post('/board/saveComment', params)
				.then(response => {
					this.commentList = response.data.result.commentList;
					this.pickCommentList = [];
				});

		},
		deleteCommentBtn() { // 댓글삭제 버튼 클릭
			if (this.pickCommentList.length < 1) {
				Vue.Alert.alert('선택된 항목이 없습니다. 항목을 선택해주세요.');
				return false;
			}

			const params = {
				bulletinBoardNo: this.refBoardNo,
				bulletinContentNoList: this.pickCommentList
			}

			Vue.httpClient
				.post('/board/deleteComment', params)
				.then(response => {
					this.commentList = response.data.result.commentList;
					this.pickCommentList = [];
				});

		},
		selectContentDetail() { // 게시글 상세 조회
			const params = {
				bulletinBoardNo: this.refBoardNo
			}
			Vue.httpClient
				.post('/board/list/content-detail', params)
				.then(response => {
					if (response.data.result) {
						this.setMainContent(response.data.result);
					}
				});
		},
		setMainContent(dataList) { // 게시글 내용 설정
			const mainContent = dataList.contentDetail[0];
			// 게시글 설정
			this.contentObj.subject = mainContent.bulletinBoardTitle;
			this.contentObj.content = this.htmlEntities(mainContent.mainContent);
			this.authUserNo = mainContent.updateUserNo;
			this.noticeOption.typeCode = mainContent.bulletinBoardTypeCode;
			this.noticeOption.isFixUpper = mainContent.priority == 0 ? true : false;
			this.noticeOption.PopupShow = mainContent.popupYn;
			this.noticeOption.showStDate = mainContent.popupStartDate;
			this.noticeOption.showEdDate = mainContent.popupEndDate;
			// 댓글 설정
			this.commentList = dataList.commentList;
			// 첨부 파일 설정
			this.uploadFileList = dataList.attachedFileList;
			if (dataList.attachedFileList.length > 0) {
				this.contentObj.fileGroupNo = mainContent.fileGroupNo;
			}
			if (mainContent.imageGroupNo == undefined || mainContent.imageGroupNo == null) {
				this.contentObj.imageGroupNo = 0;
			} else {
				this.contentObj.imageGroupNo = mainContent.imageGroupNo;
			}
		},
		htmlEntities(str) { // 태그 변경처리
			let result = String(str).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
			result = result.replace(/<[^>]+/g, match1 => {
				return match1.replace(/ on\w+=*/g, match2 => {
					return match2.replace(/on/g, 'data-');
				})
			});
			return result;
		},
		addFileFunc(event) { // 파일 리스트에 추가
			const fileInfoList = event.target.files;
			let params = new FormData();
			params.append("refBoardNo", this.refBoardNo);
			
			this.isCheckAll = false; // 파일 추가시 기 전체선택건 취소
			this.uploadFileCheckList = []; // 파일 추가시 기 선택건 취소

			for (let i = 0; i < fileInfoList.length; i++) {
				const fileInfo = fileInfoList[i];
				let isAddedFile = false;
				if (fileInfo.name) {
					const ext = fileInfo.name
						.substring(fileInfo.name.length, fileInfo.name.length - 3)
						.toLowerCase();
					
					if (ext == 'exe') {
						window.$Alert.alert(".exe 파일은 업로드가 불가능 합니다.");
						return;
					}

					isAddedFile = this.uploadFileList.findIndex(el => {
						return el.name == fileInfo.name;
					}) > -1 ? true : false;

					if (isAddedFile) {
						return false;
					}

					// 업로드한 파일 표시
					let tempObj = {
						origrinFileName: fileInfo.name,
						file: fileInfo
					}
					this.uploadFileList.push(tempObj);
				}
			}
		},
		clickAllUploadFile() { // 업로드 파일 전체 클릭
			if (this.uploadFileCheckList.length == this.uploadFileList.length) {
				this.uploadFileCheckList = [];
				this.isCheckAll = false;
				return false;
			}

			this.isCheckAll = true;
			for(let i in this.uploadFileList) {
				this.uploadFileCheckList.push(this.uploadFileList[i].fileNo);
			}
		},
		clickUploadFile(index) { // 업로드 파일 개별 클릭
			if (index < 0) {
				this.uploadFileCheckList = [];
				return false;
			}
			if (this.uploadFileList[index] == this.uploadFileCheckList[index]) {
				this.uploadFileCheckList.splice(index, 1);
			}

			if (this.uploadFileList.length == this.uploadFileCheckList.length
					&& this.uploadFileList.length != 0) {
				this.isCheckAll = true;
			} else {
				this.isCheckAll = false;
			}
		},
		chngCommentCheck() { // 댓글 체크박스 변경
			for (let i in this.pickCommentList) {
				let commentIdx = this.commentList.findIndex(el => {
					return el.bulletinContentNo == this.pickCommentList[i];
				});
				this.commentList[commentIdx].edit = true;
			}
		},
		isWriteUser() { // 수정 권한
			let result = false;
			if (this.isRead && this.authUserNo == this.loginUserNo
					&& AppConfig.USER_AUTH.MANAGER >= this.userRoleLevel) {
				result = true;
			}
			return result;
		},
		onEditorBlur(editor) {
			
		},
		onEditorFocus(editor) {
			
		},
		onEditorReady(editor) {
			
		},
		onImageUpload(editor) { // 이미지 업로드 실행
			const elInput = document.createElement('input');
			elInput.setAttribute('type', 'file');
			elInput.setAttribute('accept', '.gif, .jpg, .png');
			elInput.click();

			elInput.onchange = (event) => {
				this.addImage(editor, event);
			}
		},
		addImage(editor, event) { // 이미지 저장
			let fileInfo = event.target.files[0];
      let ext = fileInfo.name
        .substring(fileInfo.name.length, fileInfo.name.length - 3)
        .toLowerCase();
			
      // 파일 확장자 체크
      if (ext != "gif" && ext != "jpg" && ext != "png") {
        window.$Alert.alert("이미지파일(gif, jpg, png)만 업로드 가능합니다.");
        return;
			}

      var param = new FormData();
      param.append("file", event.target.files[0]);
			param.append("imageGroupNo", this.contentObj.imageGroupNo);
			param.append("imageTypeCode", AppConfig.IMAGE_TYPE.BOARD);
      param.append("pkNo", this.refBoardNo);
			
			
      Vue.httpClient
        .post('/common/image/upload', param, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
				})
				.then(response => {
					if (response.data.result) {
						this.contentObj.imageGroupNo = response.data.result.imageGroupNo;
						this.contentObj.trgtImageFileNo = response.data.result.imageFileNo// 1회성

					}
				})
				.then(() => {
					// 이미지 조회
					this.selectImageData(editor);
				});
		},
		selectImageData(editor) { // 게시판 글 작성시에 이미지 셋팅
			const token = window.$store.getters['Login/getToken'];
			let imageUrl =
					AppConfig.HTTP_CONFIG.baseURL + '/common/image?xAuthToken=' + token + '&imageFileNo=';
		
			imageUrl += this.contentObj.trgtImageFileNo;

			const range = editor.getSelection();
			editor.insertEmbed(range.index, 'image', imageUrl);
		},
		onVideoUpload(editor) {
			const elInput = document.createElement('input');
			elInput.setAttribute('type', 'file');
			elInput.setAttribute('accept', '.mp4, .m4v, .ogg, .avi, .WebM');
			elInput.click();
			
			elInput.onchange = (event) => {
				this.addImage(editor, event);
			}
		},
		adddVideo(editor, event) { // 비디오 저장
			let fileInfo = event.target.files[0];
      let ext = fileInfo.name
        .substring(fileInfo.name.length, fileInfo.name.length - 3)
        .toLowerCase();

      var param = new FormData();
      param.append("file", event.target.files[0]);
			param.append("imageGroupNo", this.contentObj.imageGroupNo);
			param.append("imageTypeCode", AppConfig.IMAGE_TYPE.BOARD);
			param.append("pkNo", this.refBoardNo);
			
      Vue.httpClient
        .post('/common/image/upload', param, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
				})
				.then(response => {
					if (response.data.result) {
						this.contentObj.imageGroupNo = response.data.result.imageGroupNo;
						this.contentObj.trgtImageFileNo = response.data.result.imageFileNo// 1회성

					}
				})
				.then(() => {
					// 이미지 조회
					this.selectVideoData(editor);
				});

		},
		selectVideoData(editor) { // 게시판 글 작성시에 비디오 셋팅
			const token = window.$store.getters['Login/getToken'];
			let imageUrl =
					AppConfig.HTTP_CONFIG.baseURL + '/common/image?xAuthToken=' + token + '&imageFileNo=';
		
			imageUrl += this.contentObj.trgtImageFileNo;

			const range = editor.getSelection();
			editor.insertEmbed(range.index, 'video', imageUrl);
		},
	},
}
</script>

<style scoped>
.notice_check_box {
	border: 1px solid #e8e8e8;
	height: 40px;
	text-indent: 10px;
	color: #222;
	margin-left: 50px;
	width: 20px;
}
#boardEditor {
	height: 600px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/notice/Write.vue